// 这个JS文件就是专门用于管理请求各种接口地址的
import network from './network'

export const getBanner = () => network.get('/banner?type=2')// 获取轮播图
export const getPersonalized = () => network.get('/personalized?limit=6')// 获取推荐歌单
export const getNewAlbum = () => network.get('/album/newest')// 获取最新专辑
export const getNewSong = () => network.get('/personalized/newsong')// 获取最新音乐
export const getPlayList = (data) => network.get('/playlist/detail', data)// 获取歌单详情
export const getAlbum = (data) => network.get('/album', data) // 获取专辑详情
export const getSongDetail = (data) => network.get('/song/detail', data) // 获取歌曲详情
export const getSongLyric = (data) => network.get('/lyric', data) // 获取歌词
export const getSongUrl = (data) => network.get('/song/url', data) // 获取音乐URL
export const getArtistSongs = (data) => network.get('/artists', data) // 获取歌手单曲
export const getAllList = () => network.get('/toplist') // 获取所有榜单
export const getSearchList = (data) => network.get('/search?type=1', data) // 获取搜索列表
export const getSearchHot = () => network.get('/search/hot') // 获取热门搜索词条

export const getHotArtists = () => {
  return new Promise(function (resolve, reject) {
    network.get('/top/artists?offset=0&limit=5') // 获取热门歌手
      .then(function (result) {
        resolve(result.artists)
      })
      .catch(function (err) {
        reject(err)
      })
  })
}
export const getLetterArtists = (letter) => {
  return new Promise(function (resolve, reject) {
    let letterArtists = []
    network.all([
      network.get(`/artist/list?offset=0&limit=2&type=1&area=7&initial=${letter}`)
      // network.get(`/artist/list?offset=0&limit=1&type=2&area=7&initial=${letter}`),
      // network.get(`/artist/list?offset=0&limit=1&type=3&area=7&initial=${letter}`),
      // network.get(`/artist/list?offset=0&limit=1&type=1&area=96&initial=${letter}`),
      // network.get(`/artist/list?offset=0&limit=1&type=2&area=96&initial=${letter}`),
      // network.get(`/artist/list?offset=0&limit=1&type=3&area=96&initial=${letter}`)
      // network.get(`/artist/list?offset=0&limit=1&type=1&area=8&initial=${letter}`),
      // network.get(`/artist/list?offset=0&limit=2&type=2&area=8&initial=${letter}`),
      // network.get(`/artist/list?offset=0&limit=5&type=3&area=8&initial=${letter}`)
      // network.get(`/artist/list?offset=0&limit=5&type=1&area=16&initial=${letter}`),
      // network.get(`/artist/list?offset=0&limit=5&type=2&area=16&initial=${letter}`),
      // network.get(`/artist/list?offset=0&limit=5&type=3&area=16&initial=${letter}`),
      // network.get(`/artist/list?offset=0&limit=5&type=1&area=0&initial=${letter}`),
      // network.get(`/artist/list?offset=0&limit=5&type=2&area=0&initial=${letter}`),
      // network.get(`/artist/list?offset=0&limit=5&type=3&area=0&initial=${letter}`)
    ])
      .then(function (result) {
        // console.log(result)
        result.forEach(function (item) {
          letterArtists.push(...item.artists)
        })
        resolve(letterArtists)
      })
      .catch(function (err) {
        reject(err)
      })
  })
}
export const getAllArtists = (letter) => {
  return new Promise(function (resolve, reject) {
    let keys = ['热']
    let list = [getHotArtists()]
    for (let i = 65; i < 91; i++) {
      let char = String.fromCharCode(i)
      // console.log(char)
      keys.push(char)
      list.push(getLetterArtists(char))
    }
    network.all(list)
      .then(function (result) {
        let obj = {}
        obj.keys = keys
        obj.list = result
        resolve(obj)
      })
      .catch(function (err) {
        reject(err)
      })
  })
}
export const getTopListDetail = () => {
  return new Promise(function (resolve, reject) {
    let category = {
      officialList: [
        { name: '飙升榜', id: 3 },
        { name: '新歌榜', id: 0 },
        { name: '原创榜', id: 2 },
        { name: '热歌榜', id: 1 }
      ],
      recList: [
        { name: '云音乐说唱榜', id: 23 },
        { name: '云音乐电音榜', id: 25 },
        { name: '云音乐欧美新歌榜', id: 32 },
        { name: '网络热歌榜', id: 26 },
        { name: '云音乐ACG榜', id: 22 },
        { name: '云音乐古典榜', id: 24 }
      ],
      globalList: [
        { name: '美国Billboard榜', id: 6 },
        { name: 'UK排行榜周榜', id: 5 },
        { name: 'Beatport全球电子舞曲榜', id: 21 },
        { name: '日本Oricon榜', id: 10 },
        { name: '俄罗斯top hit流行音乐榜', id: 8 },
        { name: '云音乐ACG VOCALOID榜', id: 29 }
      ],
      otherList: [
        { name: '中国新乡村音乐排行榜', id: 7 },
        { name: '中文DJ榜', id: 19 },
        { name: '潜力爆款榜', id: 27 },
        { name: '云音乐韩语榜', id: 28 },
        { name: 'KTV唛榜', id: 30 },
        { name: '云音乐欧美热歌榜', id: 31 }
      ],
      titles: { officialList: '官方榜', recList: '推荐榜', globalList: '全球榜', otherList: '更多榜单' }
    }
    network.get('/toplist/detail')
    // getAllList()
    // network.get('/toplist')
      .then(function (data) {
        data.list.forEach(function (obj) {
          let flag = false
          for (let key in category) {
            for (let i = 0; i < category[key].length; i++) {
              if (category[key][i].name === obj.name) {
                category[key][i].rank = obj
                flag = true
                break
              }
            }
            if (flag) {
              break
            }
          }
        })
        resolve(category)
      })
      .catch(function (err) {
        reject(err)
      })
  })
}
